<div class="flex w-full gap-2">
  <phoenix-server-side-autocomplete
    title="Client"
    [control]="control"
    [serverCallback]="clientsAutocomplete"
    (valueChange)="clientChanged($event)"
    (valueResolved)="onValueResolved($event)"
    attrToSave="id"
    attrFilter="fullName"
    [optionHtml]="getOptionHtml"
    [sortOptions]="sortOptions"
    [showClearButton]="true"
    [errorMessages]="errorMessage"
    [refresh]="refresh()"
    [autoFocus]="autoFocus"
    [ngClass]="{
      'w-[70%]': partnerInfo.value !== '',
      'w-full': partnerInfo.value === '',
    }"
  ></phoenix-server-side-autocomplete>
  @if (partnerInfo.value !== '') {
    <mat-form-field class="w-[30%]">
      <mat-label>Partner Info</mat-label>
      <mat-select
        [formControl]="partnerInfo"
        (selectionChange)="onPartnerInfoChange($event.value)"
        aria-label="'client-filter-partner-info'"
      >
        <mat-option value="ALL">Show All</mat-option>
        <mat-option value="PSCU">No PSCU</mat-option>
        <mat-option value="NICE_ACTIMIZE">No Nice Actimize</mat-option>
        <mat-option value="DEFENSE_STORM">No Defense Storm</mat-option>
      </mat-select>
      <mat-error> <small>This field is required</small></mat-error>
    </mat-form-field>
  }
</div>
